import React, { useState, useEffect } from "react";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import getUserGroup from "../../shared/components/getUserGroup";
import Preloader from "../../shared/components/Preloader";
import Modal from "../../shared/components/Modal";
import PatientTable from "./PatientTable";

const PatientList = ({ isOpen, onClose, onSelectPatient }) => {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) return;

    const fetchPatients = async () => {
      setLoading(true);
      setError("");
      setPatients([]);

      try {
        const db = getFirestore();
        const group = await getUserGroup();

        if (!group) {
          setError("No se pudo obtener el grupo del usuario.");
          setLoading(false);
          return;
        }

        const patientsCollection = collection(db, "registeredPatients");
        const q = query(patientsCollection, where("group", "==", group));
        const querySnapshot = await getDocs(q);

        let patientList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        patientList.sort((a, b) =>
          a.name.localeCompare(b.name, "es", { sensitivity: "base" })
        );

        setPatients(patientList);
      } catch (error) {
        setError("Se produjo un error al obtener los pacientes.");
      } finally {
        setLoading(false);
      }
    };

    fetchPatients();
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2>Listado de Pacientes</h2>
      {loading ? (
        <Preloader />
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <PatientTable patients={patients} onSelectPatient={onSelectPatient} />
      )}
    </Modal>
  );
};

export default PatientList;
